import _ from 'lodash';
import React from 'react';
import { MultiSelect } from '~/components';
import { events } from '../lookups';

const options = _.values(events);

export default function HistoryEventFilter({
  materialPlaceholder = 'Event',
  placeholder = 'All',
  name,
  value,
  onChange,
}) {
  return (
    <MultiSelect.Filter
      materialAlwaysVisible
      materialPlaceholder={materialPlaceholder}
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
